import { createContext, useContext } from 'react';

export interface Logger {
  error(message: string, error?: Error): void;
  warn(message: string): void;
  info(message: string): void;
}

export const defaultLogger: Logger = {
  error: (message: string, error?: Error) => {
    if (import.meta.env.DEV) {
      console.error(`[ERROR] ${message}`, error);
    }
  },
  warn: (message: string) => {
    if (import.meta.env.DEV) {
      console.warn(`[WARN] ${message}`);
    }
  },
  info: (message: string) => {
    if (import.meta.env.DEV) {
      console.info(`[INFO] ${message}`);
    }
  },
};

export const LoggerContext = createContext<Logger>(defaultLogger);

export const useLogger = (): Logger => {
  return useContext(LoggerContext);
};
